import CryptoPrices from "components/homeComponent/CryptoPrices";
import styles from "./sarafi.module.css";
import log from "../../assets/images/log.svg";
// import TakTwitte from "components/common/twitte/TakTwitte";
import { RiMessage2Line } from "react-icons/ri";
import { useState, useContext } from "react";
import sec from "../../assets/images/first.png";
import second from "../../assets/images/second.png";
import third from "../../assets/images/third.png";
import user from "../../assets/images/Icon awesome-user-alt.png";
import icon from "assets/images/Icon awesome-twitter.png";
// import twitteContext from "context/twitteContext";
// import imageTwitter from "../../assets/images/ImageTwitter.png";
import more from "assets/images/Icon awesome-angle-left.png";
// import ModalTwit from "components/common/ModalTwit";

function SarafiComponent({ allTwittes, firstTwittes }) {
  const [visible, setVisible] = useState(true);
  // const { setTwittes } = useContext(twitteContext);
  const [twittes, setTwitte] = useState([
    {
      key: 1,
      parentKey: 1,
      type: 1,
      name: "بورس نگر",
      id: "boursnegar",
      image: second,
      time: "later",
      hashtag: [{ value: "پالایش" }],
      content: {
        type: 1,
        value: {
          text: `خروج سنگین پول امروز از صندوق های درآمد ثابت شاید نوید
    خوبی برای رشد بازارهست ،و اینکه وزیر اقتصاد سه شنبه به
    مجلس میرود ،حالا تصمیم فروش با خودتان`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
    },
    {
      key: 2,
      parentKey: 2,
      type: 1,
      name: "رامی",
      id: "rami",
      image: second,
      time: "later",
      hashtag: [{ value: "خودرو" }],
      content: {
        type: 1,
        value: {
          text: `
      خبر بسیار مهم ایرانخودرو
     ا یران خودرو برنامه واگذاری شرکتهای غیربورسی خود از طریق 
     پذیرش در بازار سرمایه و عرضه اولیه آنها را در دست اقدام دارد 
      عرضه اولیه سمند نزدیکه `,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
    },
    {
      key: 1,
      parentKey: 1,
      type: 1,
      name: "بورس نگر",
      id: "boursnegar",
      image: second,
      time: "later",
      hashtag: [{ value: "پالایش" }],
      content: {
        type: 1,
        value: {
          text: `خروج سنگین پول امروز از صندوق های درآمد ثابت شاید نوید
    خوبی برای رشد بازارهست ،و اینکه وزیر اقتصاد سه شنبه به
    مجلس میرود ،حالا تصمیم فروش با خودتان`,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
    },
    {
      key: 2,
      parentKey: 2,
      type: 1,
      name: "رامی",
      id: "rami",
      image: second,
      time: "later",
      hashtag: [{ value: "خودرو" }],
      content: {
        type: 1,
        value: {
          text: `
      خبر بسیار مهم ایرانخودرو
     ا یران خودرو برنامه واگذاری شرکتهای غیربورسی خود از طریق 
     پذیرش در بازار سرمایه و عرضه اولیه آنها را در دست اقدام دارد 
      عرضه اولیه سمند نزدیکه `,
          image: null,
        },
      },
      statistics: {
        comment: 3,
        like: 17,
        dislike: 4,
      },
    },
  ]);
  return (
    <div>
      <CryptoPrices
        doj="والکس"
        ltc="رمزینکس"
        etr="بایننس"
        dash="نوبیتکس"
        xrp="رمزینکس"
      />

      <div
        className={`my-2 d-flex justify-content-around py-5 px-md-5 px-sm-4  ${styles.purple}`}
      >
        <img src={log} className={styles.logoSt} />
        <div className="m-2  px-md-5 px-sm-4  d-flex flex-column align-items-start justify-content-around">
          <h4 className="mb-1">درباره صرافی اوکی اکسچنج</h4>
          <div className={styles.divid}></div>
          <p>
            تقریبا در ۶ سال قبل بود که شرکت آماتیس کار خود را با سه نفر از
            علاقمندان به برنامه نویسی وب آغاز کرد. تمرکز ما در این سال ها ایجاد
            استارت آپ هایی در جهت ارائه خدمات مالی و رفع نیاز های کاربرانی بود
            که به دلایل تحریم و غیره به اکثر خدمات نرم افزاری دسترسی نداشتند.
          </p>
        </div>
      </div>
      <div className={`text-center my-5 container1 ${styles.hashtad}`}>
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "25px",
              marginBottom: "29px",
            }}
          >
            <RiMessage2Line
              data-bs-toggle="modal"
              data-bs-target={`#exampleModal2`}
              style={{ cursor: "pointer" }}
            />
            {/* <ModalTwit /> */}
            <img src={icon} alt="icon" className="mx-2" />
            توییت ها
          </div>
          {twittes.map((value, index) => (
            <div className="container1">
              {/* <TakTwitte value={value} index={index} twittes={twittes} /> */}
            </div>
          ))}
          <div className="m-auto my-4 w-100 d-flex justify-content-center">
            <div
              className="col-12 moreT"
              style={{ textAlign: "-webkit-center" }}
            >
              {visible ? (
                <button
                  type="button"
                  class="btn btn-primary"
                  onClick={(e) => {
                    // setTwittes(allTwittes);
                    setVisible(false);
                  }}
                >
                  مطالب بیشتر
                </button>
              ) : (
                <div
                  className="more"
                  onClick={(e) => {
                    // setTwittes(firstTwittes);
                    setVisible(true);
                  }}
                  style={{ marginBottom: "50px" }}
                >
                  <img
                    src={more}
                    alt="more"
                    style={{ transform: "rotateX(180deg)" }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SarafiComponent;
